const OnboardingStepsUtility = () => <h1>Onboarding steps utility</h1>;

export default OnboardingStepsUtility;
